export enum ParameterActivationEnum {
  NON_REGLEMENTAIRE_ACTIVATION = "NON_REGLEMENTAIRE_ACTIVATION",
  GDP_ACTIVATION = "GDP_ACTIVATION",
  ACQUISITION_ACTIVATION = "ACQUISITION_ACTIVATION",
  SEQUENCE_MATCHABLE = "SEQUENCE_MATCHABLE",
  DETAILED_FACETTES_ACTIVATION = "DETAILED_FACETTES_ACTIVATION"
}
